import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { loader } from "../../loader";
import { getData, postData } from "../../axios/apiHelper";
import { ENDPOINT } from "../../axios/apiConfig";
import { surveyAxiosInstance } from "../surveybuilder/CommonFunctions/CommonFunction";
const TopicModals = ({ show, setShow, topics, setShowCurrent, setTopics, allTags = [], setAllTags }) =>
{
  const path_image = process.env.REACT_APP_ASSETS_PATH_INFORMED_DESIGN;

  const [newTag, setNewTag] = useState("");
  const [error, setError] = useState("");

  const handleClose = () =>
  {
    setShow(false);
    setShowCurrent(true)
    setError("");
    setNewTag("");
  };



  const handleTagClick = (e, tag) =>
  {
    e.preventDefault()
    if (!topics.includes(tag)) {
      setTopics((prev) =>
      {
        const updated = [...prev.finalTags, tag]
        return { ...prev, finalTags: updated }
      });
    } else {
      toast.error("Topic already selected.");
    }
  };

  const removeTag = (index) =>
  {
    setTopics((prev) =>
    {
      const updated = prev.finalTags.filter((_, i) => i !== index)
      return { ...prev, finalTags: updated }
    });
  };

  const addTag = async () =>
  {

    if (typeof newTag == "undefined" || newTag.trim().length == 0) {
      setError("Please enter a topic");
      toast.error("Please enter a topic");
      return;
    }

    const lower = newTag.trim().toLowerCase();
    const allExisting = [...allTags, ...topics].map((t) => t.toLowerCase());

    if (allExisting.includes(lower)) {
      toast.error("Topic already exists.");
      return;
    }

    try {
      loader("show");
      await postData(ENDPOINT.ADD_SPC_PRODUCT, {
        user_id: localStorage.getItem("user_id"),
        product: newTag.trim(),
        category: 0,
        type: 2,
      });
      loader("hide");
    } catch (err) {
      loader("hide");
      toast.error("Failed to add topic");
      return;
    }

    setTopics((prev) => ({
      ...prev,
      finalTags: [...(prev.finalTags || []), newTag.trim()],
    }));
    setNewTag("");
    setError("");
  };

  return (
    <Modal show={show} id="tagsModal" onHide={handleClose} backdrop="static" className="narrative-tag-modal">
      <Modal.Header>
        <h5>Edit Topics</h5>
        <button type="button" className="btn-close" onClick={handleClose}></button>
      </Modal.Header>
      <Modal.Body>
        <div className="select-tags">
          <h6>Select Topics :</h6>
          <div className="tag-lists">
            <div className="tag-lists-view">
              {allTags?.map((tag, idx) => (
                <div key={idx} onClick={(e) => handleTagClick(e, tag)}>
                  {tag}
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="selected-tags">
          <h6>
            Selected topics <span>| {topics.length}</span>
          </h6>
          <div className="total-selected">
            <div className="topics-scroll">
              {topics.map((tag, index) => (
                <div className="tag-cross" key={index}>
                  {tag}
                  <img
                    src={path_image + "filter-close.svg"}
                    alt="Remove"
                    onClick={() => removeTag(index)}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </Modal.Body>


      <Modal.Footer>
        <form>
          <div className="form-group">
            <label htmlFor="new-tag">New Topic</label>
            <input
              type="text"
              className="form-control"
              id="new-tag"
              value={newTag}
              onChange={(e) => setNewTag(e.target.value)}
            />

            <button
              onClick={addTag}
              type="button"
              className="btn btn-primary add btn-bordered"
            >
              Add
            </button>
          </div>
        </form>
        <button
          type="button"
          className="btn btn-primary save btn-filled"
          onClick={handleClose}
        >
          Save
        </button>
      </Modal.Footer>

    </Modal>
  );
};

export default TopicModals;
